export const isMobile = () => {
  const { userAgent } = navigator;
  const isAndroid = userAgent.match(/Android/i);
  const isBlackBerry = userAgent.match(/BlackBerry/i);
  const isIOS = userAgent.match(/iPhone|iPad|iPod/i);
  const isOpera = userAgent.match(/Opera Mini/i);
  const isWindows =
    userAgent.match(/IEMobile/i) || userAgent.match(/WPDesktop/i);

  return {
    android: isAndroid,
    blackBerry: isBlackBerry,
    iOS: isIOS,
    opera: isOpera,
    windows: isWindows,
    any: isAndroid || isBlackBerry || isIOS || isOpera || isWindows,
  };
};

export const isiOS = () => isMobile().iOS;
